export enum FieldNameEnumsActionPlan {
    CREATED_AT = "created_at",
    DUE_DATE = "due_date",
    NAME = "name",
    MEETING_TYPE_ID = "meeting_type_id",
    DESCRIPTION = "description",
    PRIORITY_ID = "priority_id",
    ASSIGNEE_ID = "assignee_id",
    STATUS_ID = "status_id",
    DELETED_AT = "deleted_at",
    ACTION_PLAN_TASK_DESCRIPTION = "action_plan_task_description",
    ACTION_PLAN_TASK_DELETED_AT = "action_plan_task_deleted_at",
    ACTION_PLAN_TASK_COMPLETED_AT = "action_plan_task_completed_at",
    ACTION_PLAN_MEDIA_CREATED_AT = "action_plan_media_created_at",
    ACTION_PLAN_MEDIA_DELETED_AT = "action_plan_media_deleted_at",
}

export enum FieldNameEnumsIssue {
    CREATED_AT = "created_at",
    DUE_DATE = "due_date",
    INCIDENT_DATE = "incident_date",
    TITLE = "title",
    OWNER_ID = "owner_id",
    MILL_ID = "mill_id",
    MEETING_TYPE_ID = "meeting_type_id",
    DESCRIPTION = "description",
    PRIORITY_ID = "priority_id",
    STATUS_ID = "status_id",
    DELETED_AT = "deleted_at",
    ACTION_PLAN_CREATED_AT = "action_plan_created_at",
    ACTION_PLAN_DELETED_AT = "action_plan_deleted_at",
    ISSUE_MEDIA_CREATED_AT = "issue_media_created_at",
    ISSUE_MEDIA_DELETED_AT = "issue_media_deleted_at",
}

export enum FieldNameEnumsRCA {
    CREATED_AT = "created_at",
    DUE_DATE = "due_date",
    INCIDENT_DATE = "incident_date",
    OWNER_ID = "owner_id",
    MILL_ID = "mill_id",
    MEETING_TYPE_ID = "meeting_type_id",
    INCIDENT_DESCRIPTION = "incident_description",
    STATUS_ID = "status_id",
    DELETED_AT = "deleted_at",
    FIVE_WHY_ANALYSIS_ROOT_CAUSE_CONCLUSION = "five_why_analysis_root_cause_conclusion",
    FIVE_WHY_ANALYSIS_PROBLEM_STATEMENT = "five_why_analysis_problem_statement",
    FIVE_WHY_ANALYSIS_MEDIA_ID = "five_why_analysis_media_id",
    WHY_QUESTION_TEXT = "why_question_text",
    WHY_ANSWER_TEXT = "why_answer_text",
    WHY_QUESTION_DELETED_AT = "why_question_deleted_at",
    WHY_ANSWER_DELETED_AT = "why_answer_deleted_at",
    FISHBONE_DIAGRAM_PROBLEM_STATEMENT = "fishbone_diagram_problem_statement",
    FISHBONE_DIAGRAM_PROBLEM_CAUSE_MAIN_ITEM_DESCRIPTION = "fishbone_diagram_problem_cause_main_item_description",
    FISHBONE_DIAGRAM_PROBLEM_CAUSE_MAIN_ITEM_DELETED_AT = "fishbone_diagram_problem_cause_main_item_deleted_at",
    FISHBONE_DIAGRAM_PROBLEM_CAUSE_MAIN_ITEM_IS_HIGHLIGHTED = "fishbone_diagram_problem_cause_main_item_is_highlighted",
    FISHBONE_DIAGRAM_PROBLEM_CAUSE_SECONDARY_ITEM_DESCRIPTION = "fishbone_diagram_problem_cause_secondary_item_description",
    FISHBONE_DIAGRAM_PROBLEM_CAUSE_SECONDARY_ITEM_DELETED_AT = "fishbone_diagram_problem_cause_secondary_item_deleted_at",
    FISHBONE_DIAGRAM_PROBLEM_CAUSE_SECONDARY_ITEM_IS_HIGHLIGHTED = "fishbone_diagram_problem_cause_secondary_item_is_highlighted",
    RCA_DETAILS_PRODUCTION_LINE_ID = "rca_details_production_line_id",
    RCA_DETAILS_MACHINE_CENTER_ID = "rca_details_machine_center_id",
    RCA_DETAILS_FAILURE_TYPE_ID = "rca_details_failure_type_id",
    RCA_DETAILS_FAILURE_CODE_ID = "rca_details_failure_code_id",
    RCA_DETAILS_SECONDARY_FAILURE_CODE_ID = "rca_details_secondary_failure_code_id",
    RCA_DETAILS_SECONDARY_FUNCTIONAL_LOCATION_ID = "rca_details_secondary_functional_location_id",
    RCA_DETAILS_SHIFT_ID = "rca_details_shift_id",
    RCA_DETAILS_FUNCTIONAL_LOCATION_ID = "rca_details_functional_location_id",
    RCA_TEAM_MEMBER_DELETED_AT = "rca_team_member_deleted_at",
    RCA_TEAM_MEMBER_USER_ID = "rca_team_member_user_id",
    ACTION_PLAN_CREATED_AT = "action_plan_created_at",
    ACTION_PLAN_DELETED_AT = "action_plan_deleted_at",
    RCA_MEDIA_CREATED_AT = "rca_media_created_at",
    RCA_MEDIA_DELETED_AT = "rca_media_deleted_at",
}

export enum ChangeTypeEnums {
    INSERT = "INSERT",
    UPDATE = "UPDATE",
    DELETE = "DELETE",
}

export interface IHistoryLogBase {
    history_id: number;
    field_name: FieldNameEnumsRCA | FieldNameEnumsIssue | FieldNameEnumsActionPlan;
    new_value: string | null;
    old_value: string | null;
    changed_at: Date;
    change_type: ChangeTypeEnums;
    user: IHistoryLogUser;
}

export interface IHistoryLogUser {
    first_name: string;
    last_name: string;
    media: {
        media_url: string;
    };
}
